import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({ title, description, keywords, image, url, fullTitle }) => {
    const siteName = "McGAN'S Ooty School of Architecture";
    const defaultImage = "https://mcgansarch.com/assets/images/banner/og-home.jpg";
    const defaultUrl = "https://mcgansarch.com/";

    const finalTitle = fullTitle || (title ? `${title} | ${siteName}` : siteName);

    return (
        <Helmet>
            {/* Primary Meta Tags */}
            <title>{finalTitle}</title>
            <meta name="title" content={finalTitle} />
            {description && <meta name="description" content={description} />}
            {keywords && <meta name="keywords" content={keywords} />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url || defaultUrl} />
            <meta property="og:title" content={finalTitle} />
            {description && <meta property="og:description" content={description} />}
            <meta property="og:image" content={image || defaultImage} />
            <meta property="og:site_name" content={siteName} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url || defaultUrl} />
            <meta property="twitter:title" content={finalTitle} />
            {description && <meta property="twitter:description" content={description} />}
            <meta property="twitter:image" content={image || defaultImage} />

            {/* Canonical */}
            <link rel="canonical" href={url || defaultUrl} />
        </Helmet>
    );
};

export default SEO;
